import React from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import LimitedBackdropLoading from 'components/Loading/LimitedBackdropLoading';
import { resetState } from 'redux/slices/filesSlice';
import { filesSelector } from 'redux/selectors';
import { STATUS } from 'constants/thunkStates';
import { downloadSuccess } from 'redux/slices/filesSlice';

const StyledPaper = styled(Paper)`
  padding: 2rem;
  margin: auto;
  width: 40vw;
  max-height: 90vh;
  overflow: auto;
  text-align: center;
  border: 2px solid #000;
  box-shadow: ${(p) => p.theme.shadows[5]};
`;

function ViewClientModal({ handleClose, clientData }) {
  const dispatch = useDispatch();
  const { status, error } = useSelector(filesSelector);

  const handleDownloadSuccess = () => {
    const data = { fileId: clientData.id_file, name: `operacion_id_${clientData.id}` };
    dispatch(downloadSuccess(data))
      .then((res) => {
        if (res?.meta?.requestStatus === 'fulfilled') {
          handleClose();
          dispatch(resetState());
        }
      });
  };

  return (
    <StyledPaper elevation={3}>
      <Typography variant="text" gutterBottom>
        ¿Desea descargar los documentos de la operación?
      </Typography>
      {status === STATUS.pending && <LimitedBackdropLoading size={50} />}
      {status === STATUS.error && (error.description || error.message)}
      <Box
        mt={3}
        p={2}
        display="flex"
        flexDirection="row"
        flexGrow={1}
        justifyContent="center"
      >
        <Box p={1}>
          <Button
            onClick={handleClose}
            fullWidth
            color="secondary"
            variant="contained"
            disabled={status === STATUS.pending ? true : false}
          >
            Cancelar
          </Button>
        </Box>
        <Box p={1}>
          <Button
            onClick={handleDownloadSuccess}
            fullWidth
            color="primary"
            variant="contained"
            disabled={status === STATUS.pending ? true : false}
          >
            Generar
          </Button>
        </Box>
      </Box>
    </StyledPaper>
  );
}

export default ViewClientModal;
